import React, { useState, useEffect, useContext } from 'react';
import { GlobalContext } from '../Contexts/GlobalContext';
import { getCookie } from '../Util/Cookie';
import { isItTestEnvironment } from '../Util/TestOrProd';

export default function useFetch(initialURL) {

    const [response, setData] = useState([]);
    const globalContext = useContext(GlobalContext);
    const [fetchParams, fetchData] = useState({ url: '', method: '', postData: {}, headers: [], addTokenHeader: false, multipart: false, returnRawResponse: false, hideMessageBox: true })

    useEffect(() => {

        

        const fetchData = async () => {
            let headers;

            if (!fetchParams.multipart) {
                headers = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                };
            }
            else {
                headers = {
                    'Accept': 'multipart/form-data',
                    'Content-Type': 'multipart/form-data',
                };
            }

            let authValue = 'Bearer ' + getCookie('token');
            if (fetchParams.addTokenHeader) {
                headers = {
                    ...headers,
                    'Authorization': authValue
                };
            }

            if (fetchParams.headers != null) {
                fetchParams.headers.map(header =>
                    headers[header.name] = header.value
                )
            }

            let bodyData = null;
            if (fetchParams.method == 'POST' || fetchParams.method == 'PUT' || fetchParams.method == 'DELETE') {
                if (fetchParams.multipart) {
                    bodyData = fetchParams.postData;
                } else {
                    bodyData = JSON.stringify(fetchParams.postData);
                }
            }



            if (fetchParams.url != '') {

                let apiDomain = isItTestEnvironment() ? 'https://testapi.happytable.app' : 'https://api.happytable.app';


                let requestToURL = apiDomain + fetchParams.url;
                //requestToURL = 'http://ec2-35-167-199-128.us-west-2.compute.amazonaws.com' + fetchParams.url;
                fetch(
                    requestToURL,
                    {
                        method: fetchParams.method,
                        mode: 'cors',
                        headers: headers,
                        body: bodyData,
                    }
                )
                    .then(
                        response => {
                            if (fetchParams.returnRawResponse) { //bazen response daki error code lari ayiklamak icin raw response lazim oluyor
                                setData(response);
                            }
                            else {
                                if (response.ok) {
                                    response.json().then(
                                        responseJson => setData(responseJson)
                                    ).catch(
                                        err =>
                                            setData('no response' + Math.random())
                                    )
                                }
                                else {

                                    console.log(response);
                                    let msg = 'response status: ' + response.status + ' status text: ' + response.statusText;


                                    setData(false);

                                    let fetchUrl = fetchParams.url;
                                    if (response.status == 401) {
                                        console.log(fetchUrl);
                                        if (fetchUrl.indexOf('auth/login') > -1) {
                                            console.log('loginden geliyor');
                                            setData({ fail: true });
                                        }
                                        else {
                                            console.log(fetchUrl);
                                            console.log(fetchUrl.indexOf('/login') > -1);
                                            console.log('burada');
                                            window.location = '/Login';
                                        }
                                    }

                                }
                            }
                            
                            if (fetchParams.doNotHideMessageBox == undefined) {    
                                globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: '', showButton: false } });
                            }
                        }

                    )
                    .catch(
                        error => {
                            console.log(error);
                            let errorMessage = "Check your internet connection please.If it is not about the internet connection, please contact support with this message: " + error;
                            globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: errorMessage, showButton: true } });
                            setData([]);
                        }
                    );

            }
        }
        fetchData();
    }
        , [fetchParams]);

    return [response, fetchData];

}